import LoadingAnimation from '../LoadingAnimation/LoadingAnimation';
import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../../helpers/StoreContext';
import Hotel from '../Hotel/Hotel';
import {Flex} from 'reflexbox';
import HotelStandin from '../HotelStandin/HotelStandin';
import "./HotelList.scss";
import {Box} from 'reflexbox';
import {DateTime} from 'luxon';

function renderHotels(hotelList){
  return hotelList.map((offer, index) => {
    return (
      <Box p={1} width={[1, 1/2, 1/2, 1/3]} key={offer.bookingKey} >
        <Hotel offer={offer} index={index}/>
      </Box>
    );
  });
}

export default observer( (props)=> {
  const rootStore = useContext(StoreContext);
  const hotelStore = rootStore.hotelStore;
  const displayStore = rootStore.displayStore;
  const hotelList = hotelStore.hotels;

  if (hotelList && hotelList.length > 0){
    displayStore.errorLoadingCode.set(false);
    displayStore.showHotelList.set(true);
  }

  if (displayStore.showHotelList.get()){

    if (hotelStore.numHotels > 0){
      // get valid date
      const fromDate = (hotelStore.validFrom !== undefined ? hotelStore.validFrom : DateTime.now()).setLocale("de");
      const fromDateFormatted = fromDate.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});
      const tillDate = fromDate.plus({days:7});
      const tillDateFormatted = tillDate.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});

      return (
        <div className='container hotellist'>
          <h2>Diese Angebotsseite ist vom {fromDateFormatted} bis {tillDateFormatted} gültig </h2>
          <div className="info-box">
            Die Angebote auf dieser Seite sind unverbindlich und nicht für dich reserviert,<br/>
            daher können wir nicht für die Verfügbarkeit der Preise und Leistungen garantieren.
          </div>
          <Flex  flexWrap="wrap" >
            {hotelList.length ? renderHotels(hotelList) : <LoadingAnimation/>}
          </Flex>
        </div>
      );
    }else{
      return (<div className='container hotellist'>
        <div className="info-box">
          Kein Angebot gefunden
        </div>
        <div>&nbsp;</div>
      </div>)
    }

  }else{
    return (
      <div className='container hotellist standin'>
        <h2>Diese Angebote sind für eine Woche verfügbar</h2>
        <Flex>
          <HotelStandin></HotelStandin>
        </Flex>
      </div>
    );
  }
});
